import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconPlaceholder = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconPlaceholder.dimensions.width} ${IconPlaceholder.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M8 15c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7ZM8 1.665A6.343 6.343 0 0 0 1.663 8c0 3.492 2.844 6.335 6.337 6.335S14.337 11.492 14.337 8 11.493 1.665 8 1.665Z"
        fill={color || Color.premiumBlack}
      />
      <Path
        d="M8 13.25A5.257 5.257 0 0 1 2.75 8 5.257 5.257 0 0 1 8 2.75 5.257 5.257 0 0 1 13.25 8 5.257 5.257 0 0 1 8 13.25Zm0-9.844a4.602 4.602 0 0 0-4.596 4.597A4.601 4.601 0 0 0 8 12.6a4.602 4.602 0 0 0 4.596-4.597A4.602 4.602 0 0 0 8 3.406Z"
        fill={color || Color.premiumBlack}
      />
      <Path
        d="M8 4.5C6.07 4.5 4.5 6.07 4.5 8s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5S9.93 4.5 8 4.5ZM10.86 8A2.865 2.865 0 0 1 8 10.861 2.865 2.865 0 0 1 5.14 8 2.865 2.865 0 0 1 8 5.139 2.865 2.865 0 0 1 10.86 8Z"
        fill={color || Color.premiumBlack}
      />
    </Svg>
  )
}

IconPlaceholder.dimensions = {
  width: 16,
  height: 16,
}

export default IconPlaceholder
